import { render, staticRenderFns } from "./CammandForm.vue?vue&type=template&id=12ed028b&scoped=true"
import script from "./CammandForm.vue?vue&type=script&lang=js"
export * from "./CammandForm.vue?vue&type=script&lang=js"
import style0 from "./CammandForm.vue?vue&type=style&index=0&id=12ed028b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed028b",
  null
  
)

export default component.exports